export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/8dee5cc1-3646-466d-be88-4d9c0487265e.png" 
                alt="Logo" 
                className="h-10 sm:h-12 w-auto"
              />
              <h3 className="font-serif text-xl sm:text-2xl font-bold">
                El poder de ser yo<span className="text-orange-400">.</span>
              </h3>
            </div>

            <h4 className="font-serif text-2xl sm:text-3xl md:text-4xl font-light leading-tight text-white mb-4 sm:mb-6">
              Crianza consciente<br />
              desde el corazón
            </h4>

            <p className="text-white/80 text-sm sm:text-base leading-relaxed max-w-md">
              Un ebook diseñado para fortalecer el amor propio, la calma y la conexión emocional en familia.
            </p>
          </div>

          {/* Links Sections */}
          <div>
            <h5 className="font-bold mb-3 sm:mb-4 text-base sm:text-lg text-white">Contenido</h5>
            <ul className="space-y-2">
              <li><a href="#content" className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm sm:text-base">Cuentos</a></li>
              <li><a href="#content" className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm sm:text-base">Actividades</a></li>
              <li><a href="#content" className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm sm:text-base">Reflexiones</a></li>
              <li><a href="#benefits" className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm sm:text-base">Beneficios</a></li>
            </ul>
          </div>

          <div>
            <h5 className="font-bold mb-3 sm:mb-4 text-base sm:text-lg text-white">Información</h5>
            <ul className="space-y-2">
              <li><a href="#faq" className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm sm:text-base">Preguntas frecuentes</a></li>
              <li><a href="#testimonials" className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm sm:text-base">Testimonios</a></li>
              <li><a href="#cta" className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm sm:text-base">Comprar</a></li>
              <li><a href="mailto:contacto@ejemplo.com" className="text-white/70 hover:text-white transition-colors cursor-pointer text-sm sm:text-base">Contacto</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
            <p className="text-white/70 text-xs sm:text-sm text-center md:text-left">
              © 2025 El poder de ser yo. Todos los derechos reservados.
            </p>

            {/* Social Icons */}
            <div className="flex gap-3 sm:gap-4">
              <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-rose-500 hover:border-transparent transition-all cursor-pointer hover:scale-110">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-rose-500 hover:border-transparent transition-all cursor-pointer hover:scale-110">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-rose-500 hover:border-transparent transition-all cursor-pointer hover:scale-110">
                <i className="ri-pinterest-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-lg flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-rose-500 hover:border-transparent transition-all cursor-pointer hover:scale-110">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>

            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/70 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
